import { Navigate, Outlet, useLocation } from "react-router-dom";
import authService from "../services/authService";


const ProtectedRoute = () => {
  const isAuth = authService.isLoggedIn();
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};



export default ProtectedRoute;
